import {Link} from 'react-router-dom';

export function CategoryLink({details, isLink = null, isNestedLink = null}) {
  if (isNestedLink) return <Link to={`/${isLink.name}/${isLink.uuid}/${isNestedLink}/${details?.uuid}`}>{details?.name}</Link>;
  return isLink ? <Link to={`/${isLink}/${details?.uuid}`}>{details?.name}</Link> : <>{details?.name}</>;
}
